export const VIEWS = {
  home: 1,
  emailHome: 2,
  documents: 3,
  confirmExportEmail: 4,
  successExportEmail: 5,
};
